/**
 * Friendly Captcha SDK for legacy (Twig) pages.
 * Auto-initializes widgets on elements with class "frc-captcha" and data-sitekey.
 */
import { FriendlyCaptchaSDK } from "@friendlycaptcha/sdk"

declare global {
    interface Window {
        frcaptcha: FriendlyCaptchaSDK
    }
}

const sdk = new FriendlyCaptchaSDK()
window.frcaptcha = sdk

function main() {
    sdk.attach()
}

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", main)
} else {
    main()
}
